import $ from 'jquery';

const brockmeyer = () => {
  $('.toggle-head').on('click', function() {
    $(this)
      .next().next('.toggle-content')
      .toggleClass('toggle-visible');

    $(this)
      .next('.line-pricing-classes')
      .children('.plus')
      .toggleClass('plus-visible');

    if (
      $(this)
        .find('span')
        .text() === 'öffnen'
    ) {
      $(this)
        .find('span')
        .text('schließen');
    } else {
      $(this)
        .find('span')
        .text('öffnen');
    }
  });
};

export default brockmeyer;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/additional/brockmeyer.js